export const applyFilterAreaHeight = 90;
